"use strict";
function memoize(fn, store) {
    const { get, set, toKey } = store || memoize.memStore();
    return (...args) => toKey(args)
        .catch(() => undefined)
        .then(key => (key === undefined)
        ? fn(...args)
        : get(key).catch(() => fn(...args).then(value => set(key, value).then(() => value).catch(() => value))));
}
(function (memoize) {
    function memStore(cache = new Map()) {
        return {
            get: (key) => new Promise((resolve, reject) => {
                const value = cache.get(key);
                (value === undefined) ? reject() : resolve(value);
            }),
            set: (key, value) => new Promise((resolve) => {
                cache.set(key, value);
                resolve();
            }),
            toKey: (args) => new Promise((resolve) => {
                return resolve(JSON.stringify(args));
            }),
        };
    }
    memoize.memStore = memStore;
})(memoize || (memoize = {}));
module.exports = memoize;
//# sourceMappingURL=index.js.map